import { render, staticRenderFns } from "./companiesHomes.vue?vue&type=template&id=e0f464a8&scoped=true"
import script from "./companiesHomes.vue?vue&type=script&lang=js"
export * from "./companiesHomes.vue?vue&type=script&lang=js"
import style0 from "./companiesHomes.vue?vue&type=style&index=0&id=e0f464a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f464a8",
  null
  
)

export default component.exports